import * as React from "react";

const Spotlight = (props: {
    item: SpotlightItem
}) => {

    // return
    return <div className="widget widget-text-media carousel-compatible widget-spotlight">
        <div className="text-media-container">
            {props.item.Title &&
                <div className="text-column">
                    <div className="title">{props.item.Title}</div>
                </div>
            }
            <div className="img-column">
                {!props.item.LinkUrl
                    ? <img className="img-fluid" src={props.item.Image} alt={props.item.Title} title={props.item.Title} />
                    : <a href={props.item.LinkUrl} aria-label={props.item.Title}>
                        <img className="img-fluid" src={props.item.Image} alt={props.item.Title} title={props.item.Title} />
                      </a>
                }
            </div>
            <div className="text-column">
                {props.item.Abstract &&
                    <div className="description" dangerouslySetInnerHTML={{ __html: props.item.Abstract}}></div>
                }
                {props.item.LinkUrl &&
                    <a className="link" href={props.item.LinkUrl}>{props.item.LinkTitle}</a>
                }
            </div>
        </div>
    </div>
}

export class SpotlightItem {
    Image: string;
    Abstract: string;
    Title: string;
    LinkTitle: number;
    LinkUrl: string;
}

export default Spotlight;